import { useEffect } from 'react'
import useSWR from 'swr'

import { StrapiFileInfo } from '../../@types'
import fetcher from '../../lib/fetcher'

export const NO_REFRESH = 0

export function useGetDocuments(id: number, type?: string) {
  const { data: uploadedDocuments, error } = useSWR<StrapiFileInfo[]>(
    ['/consultations/' + id + '/document' + (type ? `?type=${type}` : ''), { auth: true }],
    fetcher.api,
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      refreshWhenOffline: false,
      refreshWhenHidden: false,
      refreshInterval: NO_REFRESH,
    }
  )

  useEffect(() => {
    if (error) {
      console.error('🔴 Error getting documents', error)
    }
  }, [error])

  return { uploadedDocuments, error }
}
